export default __webpack_public_path__ + "static/media/ColoredWater.51727771.jpg";